import SocialLinks from './SocialLink';

export default SocialLinks